import { render, staticRenderFns } from "./parte2.vue?vue&type=template&id=558e95e0&"
import script from "./parte2.vue?vue&type=script&lang=js&"
export * from "./parte2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports